import { render, staticRenderFns } from "./AlarmDistribution.vue?vue&type=template&id=1814b938&scoped=true&"
import script from "./AlarmDistribution.vue?vue&type=script&lang=js&"
export * from "./AlarmDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1814b938",
  null
  
)

export default component.exports